import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Permanently suppress ResizeObserver loop errors (benign - caused by Radix UI Select components)
// Patch ResizeObserver to prevent the error from ever being thrown
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        try { callback(entries, observer); } catch (e) { /* suppress */ }
      });
    });
  }
};

// Suppress any residual ResizeObserver errors from reaching CRA's error overlay
const suppressResizeObserver = (e) => {
  if (e?.message?.includes?.('ResizeObserver loop') || e?.reason?.message?.includes?.('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
};
window.addEventListener('error', suppressResizeObserver, true);
window.addEventListener('unhandledrejection', suppressResizeObserver, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
